export const groupUsersColumns = (navigate) => [
    { 
      Header: "Group Name", 
      accessor: "groupName",
      Cell: (props) => {
        return (
          <div
          >
            {props?.row?.original?.groupName || ""}
          </div>
        );
      },
    },
    {
      Header: "Users",
      accessor: "groupUsers",
      Cell: (props) => {
        return (
          <div>{props?.row?.original?.groupUsers || ""}</div>
        );
      },
    }
  ];